import { useContext } from 'react';
import { ModalsContext } from '../contexts/modals';

export function useModals() {
  const modals = useContext(ModalsContext);

  return modals;
}
